/**
 * Trusted Device Token Management
 * Handles storage and retrieval of device trust tokens
 */

const DEVICE_TOKEN_KEY = "__ck_device_token";

/**
 * Stores the device token in localStorage
 * Token is received after successful MFA verification with "remember device" checked
 */
export function setDeviceToken(token: string): void {
    try {
        localStorage.setItem(DEVICE_TOKEN_KEY, token);
    } catch (error) {
        console.error("Failed to store device token:", error);
    }
}

/**
 * Retrieves the device token from localStorage
 */
export function getDeviceToken(): string | null {
    try {
        return localStorage.getItem(DEVICE_TOKEN_KEY);
    } catch (error) {
        console.error("Failed to retrieve device token:", error);
        return null;
    }
}

/**
 * Checks if a device token exists
 */
export function hasDeviceToken(): boolean {
    return getDeviceToken() !== null;
}

/**
 * Clears the device token from storage
 * Use for explicit device-trust removal, not normal logout.
 * The API validates the token against its fixed 24-hour expiry on every login.
 */
export function clearDeviceToken(): void {
    try {
        localStorage.removeItem(DEVICE_TOKEN_KEY);
    } catch (error) {
        console.error("Failed to clear device token:", error);
    }
}
